export class ProvvedimentoCapitoloBilancio{
    id:number;
    anno:number;
    importo:number;
    capitoloBilancioId:number;
    capitoloBilancioDescrizione:string;
    capitoloBilancioCodice:string;
    toRemove:boolean;
}